export default "__VITE_ASSET__COIbnwOb__"